import {graphql, useStaticQuery} from "gatsby";

export const useMemberProfileImages = () => {
  const results = useStaticQuery(graphql`
  query {
    profileImages: allFile(
      filter:{
        extension: { regex: "/jpeg|jpg|png|gif/"}
        relativeDirectory: { eq: "members" }
      }
    ) {
      edges {
        node {
          name
          relativePath
          childImageSharp {
            fluid(maxWidth: 1000) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    }
  }
`);

  return results.profileImages.edges.map(result => result.node);
};